/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgShoppingCart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M.25 1.5A.75.75 0 011 .75h4a.75.75 0 01.735.603l.88 4.397H23a.75.75 0 01.737.89l-1.601 8.396a2.75 2.75 0 01-2.743 2.214H9.687a2.75 2.75 0 01-2.742-2.213L5.273 6.683a.747.747 0 01-.015-.07L4.385 2.25H1a.75.75 0 01-.75-.75zm6.666 5.75l1.5 7.494a1.25 1.25 0 001.25 1.006h9.748a1.25 1.25 0 001.25-1.006l1.43-7.494H6.915zM9 21.25a.25.25 0 100 .5.25.25 0 000-.5zm-1.75.25a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0zM20 21.25a.25.25 0 100 .5.25.25 0 000-.5zm-1.75.25a1.75 1.75 0 113.5 0 1.75 1.75 0 01-3.5 0z'
        />
      </g>
      <defs>
        <clipPath id='shopping-cart_svg__clip0_126_10463'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgShoppingCart;
